import {
  IsNotEmpty,
  IsOptional,
  IsEmail,
  ValidateNested,
} from "class-validator";

import { AddressDto } from "../common";

export class ClubRegistrationDto {
  //

  @IsNotEmpty()
  club_name: string;

  @ValidateNested()
  address: AddressDto = {};

  @IsEmail()
  @IsNotEmpty()
  email: string;

  @IsNotEmpty()
  password: string;

  @IsNotEmpty()
  phone: string;

  @IsOptional()
  website?: string;
}
